/**
 * Cost pool taxonomy shared by /costs and /reviews/settings.
 * Mirrors the backend `CostPool` union in
 * `review-service/src/budget/types.ts` (Spec 199 Phase 1).
 */
export type CostPool = 'review' | 'agent' | 'cli';
export const POOLS: readonly CostPool[] = ['review', 'agent', 'cli'] as const;
